<template>
    <div>
        <div class="weui-cells__title">修改性别</div>
        <div class="weui-cells weui-cells_radio">
            <label class="weui-cell weui-check__label" for="x11">
                <div class="weui-cell__bd">
                    <p>男</p>
                </div>
                <div class="weui-cell__ft">
                    <input type="radio" class="weui-check" name="radio1" id="x11" ref="man" @click="choose(1)" />
                    <span class="weui-icon-checked"></span>
                </div>
            </label>
            <label class="weui-cell weui-check__label" for="x12">
                <div class="weui-cell__bd">
                    <p>女</p>
                </div>
                <div class="weui-cell__ft">
                    <input type="radio" name="radio1" class="weui-check" id="x12" ref="female" @click="choose(2)" />
                    <span class="weui-icon-checked"></span>
                </div>
            </label>
            <label class="weui-cell weui-check__label" for="x10">
                <div class="weui-cell__bd">
                    <p>未知</p>
                </div>
                <div class="weui-cell__ft">
                    <input type="radio" name="radio1" class="weui-check" id="x10" ref="notknow" @click="choose(0)" />
                    <span class="weui-icon-checked"></span>
                </div>
            </label>
        </div>

        <div class="warehousing-footer-item sureinwarehousing" style="flex:2" @click="save">
            <a href="javascript:;">提 交</a>
        </div>
    </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";

export default {
  data() {
    return {
      encodeToken: "",
      platform: "",
      token: "",
      userInfo: {},
      sex: -1
    };
  },
  created() {
    let that = this;
    this.platform = this.$route.params.platform;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        that.userInfo = response.data.data;

        if (that.userInfo.sex == 0) {
          that.$refs["notknow"].checked = true;
          that.sex = 0;
        } else if (that.userInfo.sex == 1) {
          that.$refs["man"].checked = true;
          that.sex = 1;
        } else if (that.userInfo.sex == 2) {
          that.$refs["female"].checked = true;
          that.sex = 2;
        }
      })
      .catch(error => {
        console.log(error);
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    choose(n) {
      this.sex = n;
    },
    save() {
        let that = this;
      axios
        .put("/api/user/updateSex", { sex: this.sex })
        .then(res => {
          if (res.data.success) {
            weui.toast("保存成功", 1000);
            // 跳转回个人中心页面
            that.$router.push("/userInfo/"+this.platform+"/" + that.encodeToken);
          } else {
            weui.alert(res.data.message);
          }
        })
        .catch(err => {
          weui.alert("保存失败");
        });
    }
  }
};
</script>

<style scoped>
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/components/userinfos/SexEdit.vue